import {connect} from 'react-redux'
import About from '../components/About/About'

function mapStateToProps(state, props) {
  return {
    browser: state.browser
  }
}

export default connect(mapStateToProps)(About)


// WEBPACK FOOTER //
// ./src/containers/About.js